<template>
  <SfCarousel
    v-if="includeInTopMenu"
    class="topic-carousel bg-light"
    :settings="{
      autoplay: 3000,
      hoverpause: true,
    }"
  >
    <SfCarouselItem v-for="item in includeInTopMenu" :key="item.Id" class="carousel__item">
      <router-link class="text-primary" :to="`/p/${item.SeName}`">{{ item.Title }}</router-link>
    </SfCarouselItem>
  </SfCarousel>
</template>

<script>
import { SfCarousel } from '@storefront-ui/vue';
import { pages } from '@/modules/page';
import routes from '../../mixins/routes';
import config from '../../mixins/config';

export default {
  name: 'TopicSlider',
  mixins: [routes, pages, config],
  components: {
    SfCarousel,
  },
};
</script>
<style lang="scss">
@import '~@storefront-ui/shared/styles/_helpers';
@import 'src/scss/_breakpoint';
.topic-carousel .sf-carousel__controls {
  display: none;
}
.topic-carousel .sf-carousel-item {
  display: flex;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.topic-carousel a {
  text-align: center;
  display: block;
  text-transform: uppercase;
  font-size: 13px;
  text-decoration: none;
}
</style>
